import AccountsApi from '@app/api/public/AccountSettingsApi';
import { useQuery } from 'react-query';

const useGetAccount = () => {
    return useQuery('getAccount', AccountsApi.getAccount);
};

export default useGetAccount;
